import {
  Box,
  Typography,
  Paper,
  Chip,
  chipClasses,
  Button,
  TextField,
} from "@mui/material";
import { Grid } from "../../../components/table";
// import { AccountCircleOutlined, Visibility, VisibilityOff, LockOutlined, Group } from '@mui/icons-material';
import { useEffect, useMemo, useState } from "react";
import FormControl from "@mui/material/FormControl";
// import { ReportsData } from './ecd-reports-database';
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PendingIcon from "@mui/icons-material/Pending";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { ToolBar } from "../../../components/toolbar";
import dayjs from "dayjs";
import { SelectA } from "../../../components/form";
import CircularProgress from "@mui/material/CircularProgress";
import { CONFIG } from "../../../../config";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-hot-toast";

import axios from "axios";
import { get, isNull } from "lodash";
import ExportTelecallerRatingSingleModal from "./features/export-rating-telcaller-single";
const API_HOST_CRM = CONFIG.modules["crm"].host;
const API_HOST_ACCOUNT = CONFIG.modules["accounts"].host;


const TeamleadView = () => {
  const {
    roles,
    user,
    users,
    Designations,
    Departments,
    Languages,
    Districts,
    map,
  } = useSelector((state) => state.user || {});

  const [agent, setAgent] = useState(null);
  const [currentDate] = useState(new Date());
  const [loader, setLoader] = useState();
  const [filter, setFilter] = useState({
    from: dayjs(), // dayjs("01-01-2023"),
    to: dayjs(),
  });

  useEffect(() => {
    console.log("user", user);
    console.log("role", roles);
  }, [user, roles]);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [count, setCount] = useState(0);
  const [data, setData] = useState([]);

  const [formValue, setFormValue] = useState({
    CallOpening: 1,
    Tone: 1,
    Clarity: 1,
    ActiveListening: 1,
    ProcessKnowledge: 1,
    DataIntegrity: 1,
    redFlags: "",
    FeedbackToCaller: "",
  });

  const [callList, setCallList] = useState([]);
  const [callData, setCallData] = useState();
  const [casesList, setCasesList] = useState([]);
  const [qas, setQAs] = useState([]);
  const [agents, setAgents] = useState([]);

  const [isExportRatingModalOpen, setIsExportRatingModalOpen] = useState(false);
  const handleExportRatingModalOpen = () => setIsExportRatingModalOpen(true);
  const handleExportRatingModalClose = () => setIsExportRatingModalOpen(false);

  // useEffect(() => {
  //     fetchCallRecording();
  //     console.log(callReqObj && callReqObj, 'current date tme');
  // }, [])

  const toolbarButtons = useMemo(() => ([
    {
      name: "Export Rating",
      onClick: () => {
        console.log("agent", agent);
        if (!agent) {
          toast.error("Please select an agent first");
          return;
        }
        handleExportRatingModalOpen();
      },
    },
    {
      name: "Today",
      // type: 'chip',
      // icon: () => <IosShareIcon sx={{ fontSize: '1.2em' }} />,
      onClick: () => {
        setFilter({ ...filter, from: dayjs(), to: dayjs() });
      },
    },
    {
      name: "This week",
      // type: 'chip',
      // icon: () => <IosShareIcon sx={{ fontSize: '1.2em' }} />,
      onClick: () => {
        const start = dayjs().weekday(0);
        const end = start.add(7, "day");
        // console.log(start.format('DD-MM-YYYY'), end.format('DD-MM-YYYY'))
        setFilter({ ...filter, from: start, to: end });
      },
    },
  ]), [agent]);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    // setAnchorEl(event.currentTarget);
    // console.log(event.target.textContent.trim(), "event");
    // console.log(toolbarButtons && toolbarButtons, "event");
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const ratingLogicForNow = (data) => {
    let agentObject = {};

    data.forEach((d) => {
      if (!agentObject[d.caller.uuid]) {
        agentObject[d.caller.uuid] = {};
        agentObject[d.caller.uuid].qas = [d];
        agentObject[d.caller.uuid].count = 1;
      } else {
        agentObject[d.caller.uuid].qas.push(d);
        agentObject[d.caller.uuid].count += 1;
      }
    });
    let newData = [];

    Object.keys(agentObject).forEach((ag) => {
      let score = 0;

      agentObject[ag].qas.forEach((qa) => {
        let newvalue =
          Number(qa.callOpening) +
          Number(qa.tone) +
          Number(qa.clarity) +
          Number(qa.activeListening) +
          Number(qa.processKnowledge) +
          Number(qa.dataIntegrity);

        score += Number((newvalue / 6).toFixed(2));
      });

      let average = (score / (6 * agentObject[ag].count)) * 6;

      newData.push({
        agentName: agentObject[ag].qas[0].agentID,
        totalCases: agentObject[ag].count,
        overallScore: average.toFixed(2),
      });
    });
    return newData;
  };

  const getAgentsQA = (agentLocal) => {
    // quality assurances route

    if (agent == null) {
      return;
    }
    try {
      axios
        .get(
          API_HOST_CRM +
          `/quality-assurance?limit=${rowsPerPage}` +
          `&page=${page}` +
          `${filter.from
            ? `&from=${dayjs(filter.from).format("YYYY-MM-DD")}`
            : ""
          }` +
          `${filter.to ? `&to=${dayjs(filter.to).format("YYYY-MM-DD")}` : ""
          }` +
          `${filter.agentName ? `&agentName=${filter.agentName}` : ""}` +
          `${filter.overallScore ? `&overallScore=${filter.overallScore}` : ""
          }` +
          `${filter.week ? `&week=${filter.week}` : ""}`
        )
        .then((resp) => {
          if (resp.data && resp.data.success) {
            // const newData = ratingLogicForNow(resp.data.qa);
            if (resp.data && resp.data.success) {
              let tempqas = [];
              // const newData = ratingLogicForNow(resp.data.qa);
              // filter through qas to match the agent uuid;
              if (resp.data.qa.length > 0) {
                resp.data.qa.forEach((qa) => {
                  if (qa.caller.uuid === agent.user.uuid) {
                    let newvalue =
                      Number(qa.callOpening) +
                      Number(qa.tone) +
                      Number(qa.clarity) +
                      Number(qa.activeListening) +
                      Number(qa.processKnowledge) +
                      Number(qa.dataIntegrity);

                    let score = Number((newvalue / 6).toFixed(2));
                    qa.score = score;
                    tempqas.push(qa);
                  }
                });
              }

              setQAs(tempqas);
              console.log(tempqas);
              setCount(resp.data.count - 1);
            }
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } catch (e) { }
  };

  const getCases = () => {
    axios
      .get(
        API_HOST_CRM +
        `/cases?limit=${1000}` +
        `&page=${0}&type=${"attempted"}` +
        `${filter.from
          ? `&from=${dayjs(filter.from).format("YYYY-MM-DD")}`
          : ""
        }` +
        `${filter.to ? `&to=${dayjs(filter.to).format("YYYY-MM-DD")}` : ""}` +
        `${filter.status ? `&status=${filter.status}` : ""}` +
        `${filter.district ? `&district=${filter.district}` : ""}` +
        `${filter.motherId ? `&motherId=${filter.motherId}` : ""}` +
        `${filter.motherName ? `&motherName=${filter.motherName}` : ""}` +
        `${filter.contact ? `&contact=${filter.contact}` : ""}` +
        `${filter.motherStatus ? `&motherStatus=${filter.motherStatus}` : ""
        }` +
        `${filter.telecaller ? `&telecaller=${filter.telecaller}` : ""}` +
        `${filter.firstReceived ? `&firstReceived=${filter.firstReceived}` : ""
        }` +
        `${filter.cfrom
          ? `&cfrom=${dayjs(filter.cfrom).format("YYYY-MM-DD")}`
          : ""
        }` +
        `${filter.cto ? `&cto=${dayjs(filter.cto).format("YYYY-MM-DD")}` : ""
        }` +
        `${filter.week ? `&week=${filter.week}` : ""}` +
        `${filter.priority ? `&priority=${filter.priority}` : ""}`
      )
      .then((resp) => {
        if (resp.data && resp.data.success) {
          //   setCallData(
          //     resp.data.cases
          //   );
          setCasesList(resp.data.cases);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const handleAgentClick = (agentLocal) => {
    console.log("local hero", agentLocal);
    setAgent(agentLocal);
    getQAsForAgent(agentLocal);
    // getQAforAgent(agentLocal);
  };

  const getQAsForAgent = (agentLocal) => {

    if (!agentLocal) {
      return;
    }

    console.log("What agent local", agentLocal)
    setAgent(agentLocal);


    try {
      axios
        .get(
          API_HOST_CRM +
          `/quality-assurance/telecaller/rating?caller_id=${agentLocal._id}` +
          `&page=${page}` +
          `&limit=${rowsPerPage}` +
          `${filter.from
            ? `&from=${dayjs(filter.from).format("YYYY-MM-DD")}`
            : ""
          }` +
          `${filter.to ? `&to=${dayjs(filter.to).format("YYYY-MM-DD")}` : ""
          }` +
          `${filter.agentName ? `&agentName=${filter.agentName}` : ""}` +
          `${filter.overallScore ? `&overallScore=${filter.overallScore}` : ""
          }` +
          `${filter.week ? `&week=${filter.week}` : ""}`
        )

        .then((resp) => {
          if (resp.data && resp.data.success) {
            setQAs(resp.data.data);
            setCount(resp.data.count);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } catch (error) {
      console.log(error);
    }
  }

  const getQAforAgent = (agentLocal) => {
    setAgent(agentLocal);
    let tempqas = [];

    try {
      axios
        .get(
          API_HOST_CRM +
          `/quality-assurance?limit=${rowsPerPage}` +
          `&page=${page}` +
          `${filter.from
            ? `&from=${dayjs(filter.from).format("YYYY-MM-DD")}`
            : ""
          }` +
          `${filter.to ? `&to=${dayjs(filter.to).format("YYYY-MM-DD")}` : ""
          }` +
          `${filter.agentName ? `&agentName=${filter.agentName}` : ""}` +
          `${filter.overallScore ? `&overallScore=${filter.overallScore}` : ""
          }` +
          `${filter.week ? `&week=${filter.week}` : ""}`
        )
        .then((resp) => {
          if (resp.data && resp.data.success) {
            // const newData = ratingLogicForNow(resp.data.qa);
            // filter through qas to match the agent uuid;
            if (resp.data.qa.length > 0) {
              resp.data.qa.forEach((qa) => {
                if (qa.caller.uuid === agentLocal.user.uuid) {
                  let newvalue =
                    Number(qa.callOpening) +
                    Number(qa.tone) +
                    Number(qa.clarity) +
                    Number(qa.activeListening) +
                    Number(qa.processKnowledge) +
                    Number(qa.dataIntegrity);

                  let score = Number((newvalue / 6).toFixed(2));
                  qa.score = score;
                  tempqas.push(qa);
                }
              });
            }

            setQAs(tempqas);
            setCount(resp.data.count - 1);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } catch (e) { }
  };

  const getAgents = () => {
    if (!user) {
      return;
    }
    try {
      axios
        .get(API_HOST_ACCOUNT + `/get-agent-state`)
        .then((resp) => {
          if (resp.data && resp.data.success) {
            // const newData = ratingLogicForNow(resp.data.qa);

            // check if the reporting manager id is the same as the current logged in user id
            let tempAgents = [];
            let agentsResponse = resp.data.data;

            tempAgents = agentsResponse.filter(
              (ar) => ar.user.reportingManager === user._id
            );

            let properAgents = tempAgents.map(tagent => tagent.user);

            setAgents(properAgents);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } catch (e) { }
  };

  useEffect(() => {
    getAgents();
  }, []);

  // sideeffects use effect
  // will run every time there is a chage on the column input
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      // getAgentsQA();
      getQAsForAgent(agent);
      // getAgents();
    }, 500);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [filter, page, rowsPerPage]);

  return (
    <Box sx={{ display: "flex" }}>
      <Box sx={{ width: "100%" }}>
        <Box
          sx={{
            mt: 2,
            display: "flex",
            flexDirection: "column",
            flex: 1,
            minHeight: "80vh",
          }}
        >
          <Box sx={{
            pb: 1
          }}>
            <Typography variant="h5">Team Lead Insights</Typography>
          </Box>
          <Paper
            elevation={3}
            sx={{
              height: "80vh",
              overflowY: "scroll",
              width: "100%",
              padding: 2,
              display: "flex",
              flex: 1,
            }}
          >
            <Box
              component={"section"}
              sx={{
                minHeight: "100%",
                minWidth: "20rem",
              }}
            >
              <Paper
                elevation={3}
                sx={{
                  minHeight: "100%",
                  // minWidth: "25rem",

                  paddingLeft: "1rem",
                  paddingRight: "0.4rem",
                }}
              >
                {/* Section Heading */}
                <Box sx={{
                  pl: 2
                }}>
                  <h3>Agents</h3>
                </Box>
                <hr />
                {/* Telecaller List */}
                <Box
                  sx={{
                    paddingLeft: "0.1rem",
                    display: "flex",
                    overflowY: "auto",
                    flexDirection: "column",
                    height: 1,
                  }}
                >
                  {agents.map((agentLocal) => {
                    return (
                      // Telecaller Box
                      <Box
                        sx={(theme) => ({ // Use theme callback for accessing theme values
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          padding: "0.5rem 0.8rem",
                          cursor: "pointer",
                          border: '1px solid',
                          // Conditionally set border and background color
                          borderColor: agent?._id === agentLocal._id ? theme.palette.primary.main : theme.palette.divider,
                          backgroundColor: agent?._id === agentLocal._id ? theme.palette.action.selected : 'transparent',
                          borderRadius: "0.5rem",
                          marginTop: "0.4rem",
                          transition: 'background-color 0.2s ease-in-out, border-color 0.2s ease-in-out',
                          "&:hover": {
                            backgroundColor: agent?._id !== agentLocal._id ? theme.palette.action.hover : undefined, // Only apply hover if not selected
                          },
                        })}
                        onClick={() => handleAgentClick(agentLocal)}
                      >
                        <Typography variant="body1" component="span" sx={{ fontWeight: agent?._id === agentLocal._id ? 600 : 500 }}> {/* Make selected bold */}
                          {agentLocal.name}
                        </Typography>
                        <ChevronRightIcon color={agent?._id === agentLocal._id ? "primary" : "action"} /> {/* Change icon color when selected */}
                      </Box>
                      // Telecaller Box
                    );
                  })}
                </Box>
              </Paper>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                flex: 1,
                paddingLeft: "0.8rem",
              }}
            >
              {agent && (
                <Box
                  sx={{
                    paddingLeft: "0.4rem",
                  }}
                >
                  <h1>{agent.name}</h1>
                </Box>
              )}
              <ToolBar
                name={""}
                buttons={toolbarButtons}
                open={open}
                flex={"column"}
                height={"100%"}
                handleClose={handleClose}
                anchorEl={anchorEl}
                handleClick={handleClick}
                filters={[
                  {
                    field: {
                      name: "from",
                      type: "date",
                      label: "From Date",
                    },
                    onChange: (name, value) => {
                      filter[name] = value;
                      setFilter({ ...filter });
                    },
                    state: filter,
                  },
                  {
                    field: {
                      name: "to",
                      type: "date",
                      label: "To Date",
                    },
                    onChange: (name, value) => {
                      filter[name] = value;
                      setFilter({ ...filter });
                    },
                    state: filter,
                  },
                ]}
              />
              {/* <Box component="section"
              style={{
                maxHeight:"30rem",
                minHeight: "15rem",
                display:"flex",
                flexDirection: "column"
              }}
              >
                {qas.map(qa => {
                  return <Box>
                    {qa._id}
                  </Box>
                })}
              </Box> */}
              <Box sx={{ mt: 2 }}>
                <Grid
                  isSelectEnabled={false}
                  data={qas}
                  columns={[
                    {
                      id: "motherID",
                      label: "Mother ID",
                      minWidth: 70,
                    },
                    {
                      id: "ucid",
                      label: "Unique Call ID",
                      minWidth: 70,
                      //   editable: true,
                      //   onChange: (name, value) => {
                      //     filter[name] = value;
                      //     setFilter({ ...filter });
                      //   },
                      //   field: {
                      //     name: "agentName",
                      //     type: "text",
                      //     label: "Agent Name",
                      //   },
                      //   state: filter,
                    },
                    {
                      id: "agentID",
                      label: "Agent Name",
                      minWidth: 70,
                      //   editable: true,
                      //   onChange: (name, value) => {
                      //     filter[name] = value;
                      //     setFilter({ ...filter });
                      //   },
                      //   field: {
                      //     name: "agentName",
                      //     type: "text",
                      //     label: "Agent Name",
                      //   },
                      //   state: filter,
                    },
                    {
                      id: "score",
                      label: "Score",
                      minWidth: 70,
                      //   editable: true,
                      //   onChange: (name, value) => {
                      //     filter[name] = value;
                      //     setFilter({ ...filter });
                      //   },
                      //   field: {
                      //     name: "overallScore",
                      //     type: "number",
                      //     label: "Overall Score",
                      //   },
                      //   state: filter,
                    },
                  ]}
                  pagination={{
                    rowsPerPageOptions: [10, 25, 50],
                    page,
                    rowsPerPage,
                    onPageChange: (event, newPage) => {
                      setPage(newPage);
                    },
                    onRowsPerPageChange: (event) => {
                      setRowsPerPage(+event.target.value);
                      setPage(0);
                    },
                    count,
                  }}
                ></Grid>
              </Box>
            </Box>
          </Paper>
        </Box>
      </Box>
      <ExportTelecallerRatingSingleModal
        open={isExportRatingModalOpen}
        handleClose={() => handleExportRatingModalClose()}
        handleOpen={() => handleExportRatingModalOpen()}
        agent={agent}
      />
    </Box>
  );
};

export default TeamleadView;
